/**
 * Detects if the current user agent belongs to a known search engine crawler.
 * Used to gate non-essential scripts (Sentry replay, Salesforce chat) that add
 * overhead to crawler renders without providing value.
 *
 * Covers: Googlebot (including GSC inspection tool), Bingbot, Botify, and other common crawlers.
 */

const CRAWLER_UA_PATTERN =
  /googlebot|google-inspectiontool|adsbot-google|mediapartners-google|bingbot|botify|yandexbot|baiduspider|duckduckbot|slurp|facebookexternalhit|twitterbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|applebot|semrushbot|ahrefsbot/i;

export function isCrawler(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  return CRAWLER_UA_PATTERN.test(navigator.userAgent);
}


export const CRAWLER_UA_REGEX_SOURCE = CRAWLER_UA_PATTERN.source;
